module.exports = __webpack_public_path__ + "img/video-dummy.03f00177.jpg";